function FooterMenu(props) {

  return (
    <>
      <div className="text-md-end footer-links d-none d-md-block">
        {/*<a href="javascript: void(0);">About</a>*/}
        {/*<a href="javascript: void(0);">Support</a>*/}
        {/*<a href="javascript: void(0);">Contact Us</a>*/}
      </div>
    </>
);
}

export default FooterMenu
